module.exports = __webpack_public_path__ + "static/media/rhythm.02b86b6c.png";